"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.askForVoucher.name': 'Richiesta Voucher',
    'tools.askForVoucher.description': 'Rileva richieste di voucher o sconti dai messaggi degli utenti e attiva azioni voucher lato client',
};
